<template>
  <div>
    <!-- 标题区域 - 在背景图上方 -->
    <div class="tw-w-full tw-text-center tw-mb-10" style="margin-top: 100px;">
      <span class="tw-text-textMain tw-text-xl md:tw-text-4xl tw-font-bold tw-mb-4 tw-block">
        {{ $t("全球化区块链生态布局") }}
      </span>
      <span class="tw-w-full tw-text-center tw-text-xs md:tw-text-sm tw-text-textDisabled tw-block">
        {{ $t("从技术研发到生态落地，已为全球多个国家和地区提供成熟Web3开发服务") }}
      </span>
    </div>
		<div class="home-section-inner">
				<div class="we-can-do-wrapper">
					<div class="tw-flex tw-justify-left">
						<div 
							class="tab-view-container tw-flex tw-flex-col tw-justify-center tw-items-center"
							:class="{ 'animate-slide-up': isVisible }"
							style="
								background: #FFFFFF;
								box-shadow: 0px 4px 50px 0px rgba(0,44,164,0.1), inset 0px 0px 100px 0px #FFFFFF;
								border-radius: 20px;
								border: 2px solid #FFFFFF;
								padding: 40px;
								width: 287px;
							"
						>
							<!-- 四个数据项 -->
							<div class="tw-w-full">
								<div 
									v-for="(item, index) in dataList" 
									:key="index"
								>
									<!-- 内容区域 -->
									<div class="tw-flex tw-items-center tw-py-4">
										<!-- 左侧图标 -->
										<img 
											:src="item.icon" 
											alt=""
											class="tw-flex-shrink-0"
											style="width: 80px; height: 80px;"
										/>

										<!-- 右侧内容 -->
										<div class="tw-ml-4 tw-flex-1">
											<!-- 右上：数据 -->
											<div 
												class="tw-font-semibold tw-text-left tw-mb-2"
												:style="{
													fontSize: $screen.xl ? '40px' : ($screen.lg ? '32px' : '28px'),
													color: item.color
												}"
											>
												{{ animatedValues[index] }}
												<span 
													class="tw-font-semibold"
													:style="{
														fontSize: $screen.xl ? '24px' : ($screen.lg ? '20px' : '18px')
													}"
												>
													{{ $t(item.unit) }}
												</span>
											</div>

											<!-- 右下：描述 -->
											<div
												class="tw-font-semibold tw-text-left"
												style="font-weight: 600; color: #666666;"
												:style="{
													fontSize: $screen.xl ? '18px' : ($screen.lg ? '16px' : '14px')
												}"
											>
												{{ $t(item.label) }}
											</div>
										</div>
									</div>

									<!-- 分隔线（除了最后一个） -->
									<div 
										v-if="index < dataList.length - 1"
										class="tw-w-full"
										style="
											height: 1px;
											border: none;
											border-top: 1px solid;
											border-image: linear-gradient(90deg, rgba(255, 255, 255, 1), rgba(217, 217, 217, 1)) 1 1;
											margin: 8px 0;
										"
									></div>
								</div>
							</div>
						</div>
					</div>
				</div>
		</div>
  </div>
</template>

<script>
import world01 from "@/assets/home/world01.png";
import world02 from "@/assets/home/world02.png";
import world03 from "@/assets/home/world03.png";
import world04 from "@/assets/home/world04.png";

export default {
  name: 'WeCanDo',
  data() {
    return {
      tabsList: [],
      isLoading: true,
      isVisible: false,
      observer: null,
      animationStarted: false,
      dataList: [
        {
          icon: world01,
          targetValue: 6,
          unit: "家",
          label: "海内外公司",
          color: "#EEA809"
        },
        {
          icon: world02,
          targetValue: 16,
          unit: "年+",
          label: "开发经验",
          color: "#9657FC"
        },
        {
          icon: world03,
          targetValue: 200,
          unit: "+",
          label: "技术团队",
          color: "#4077F8"
        },
        {
          icon: world04,
          targetValue: 10,
          unit: "W+",
          label: "企业客户",
          color: "#64C885"
        }
      ],
      animatedValues: [0, 0, 0, 0]
    };
  },
  mounted() {
    const info = JSON.parse(localStorage.getItem('indexInfo'));
    if (info) {
      this.getList();
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    initIntersectionObserver() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isVisible) {
            this.isVisible = true;
            this.startNumberAnimation();
            this.observer.disconnect();
          }
        });
      }, {
        threshold: 0.1,
      });

      this.observer.observe(this.$el);
    },

    startNumberAnimation() {
      if (this.animationStarted) return;
      this.animationStarted = true;

      this.dataList.forEach((item, index) => {
        setTimeout(() => {
          this.animateNumber(
            0,
            item.targetValue,
            1500,
            (value) => {
              this.$set(this.animatedValues, index, Math.floor(value));
            }
          );
        }, index * 200);
      });
    },

    animateNumber(start, end, duration, callback) {
      const startTime = performance.now();
      const change = end - start;

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easeProgress = 1 - Math.pow(1 - progress, 4);
        const currentValue = start + change * easeProgress;

        callback(currentValue);

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };

      requestAnimationFrame(animate);
    },

    getList() {
      // 静态数据，无需API
    }
  }
};
</script>

<style scoped lang="scss">
.we-can-do-wrapper {
  width: 100%;
  padding: 20px 0px;
  background: url('~@/assets/home/world.png') no-repeat content-box;
  background-size: cover;
  background-position: center top;
  
  @media (min-width: 768px) {
    padding: 20px 0px;
  }
}

.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}
</style>
